import React from 'react';

import styles from './Bouton.module.scss';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { VscRefresh } from 'react-icons/vsc';
import { IoIosClose } from 'react-icons/io';
import { FiMaximize, FiMinimize } from 'react-icons/fi';

/**
 * Seules valeurs valides pour l'attribut type d'un <button>.
 *
 * props.type sert d'abord à choisir le style (glossaire_type_de_bouton :
 * 'success', 'danger', 'refresh'…). Ces valeurs n'existent pas en HTML, et la
 * spécification impose de traiter un type invalide comme submit : les boutons
 * stylisés devenaient donc des boutons de soumission involontaires. Dans un
 * <form>, la touche Entrée déclenchait alors le premier d'entre eux, souvent
 * « Annuler ».
 *
 * On ne laisse donc passer dans l'attribut HTML que les vraies valeurs. Pour un
 * bouton de soumission délibéré : type="submit", ou la prop typeHtml qui permet
 * de le faire sans renoncer au style.
 */
const TYPES_HTML = ['submit', 'reset', 'button'];

const Bouton = (props) => {
  let classesBouton = [s.btn, s.btn_sm, props.ajoutClass, styles.btnATEsTER];

  if (props.rond) {
    classesBouton.push(styles.btnCircle);
  }

  //icône à afficher dans le bouton avant le text
  let icone = null;

  //type de bouton en fonction de props.types
  switch (props.type) {
    case type_btn.lupeSearchClose:
      classesBouton.push(styles.lupeSearchClose);

      break;
    case type_btn.lupeSearch:
      classesBouton.push(styles.lupeSearch);

      break;
    case type_btn.succeSimple:
      classesBouton.push(styles.succeSimple);

      break;
    case type_btn.succes:
      classesBouton.push(styles.btnSuccess);

      break;
    case type_btn.btnDisable:
      classesBouton.push(styles.btnSuccessDisable);

      break;
    case type_btn.danger:
      classesBouton.push(styles.btnDanger);

      break;
    case type_btn.Wait:
      classesBouton.push(styles.btnWait);

      break;
    case type_btn.actualiser:
      classesBouton.push(styles.btnSuccess);

      icone = <VscRefresh size={15} />; //icône de refresh qui s'affiche avant le text
      break;
    case type_btn.fermer:
      classesBouton.push(styles.btnFermer);

      icone = <IoIosClose size={30} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.Max:
      classesBouton.push(styles.btnMax);

      icone = <FiMaximize size={20} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.Min:
      classesBouton.push(styles.btnMin);

      icone = <FiMinimize size={20} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.popupferme:
      classesBouton.push(styles.popupferme);

      icone = <IoIosClose size={18} />; //icône de refresh qui s'affiche avant le text

      break;
    case type_btn.outil:
      classesBouton.push([styles.btnOutil, styles.btnCircle].join(' '));

      break;
    default:
      classesBouton.push(s.btn_primary);
  }

  let contentHoverText;
  if (props.hoverText !== undefined) {
    contentHoverText = (
      <span className={styles.classdutexte}>{props.hoverText}</span>
    );
  }

  return (
    <button
      type={
        TYPES_HTML.includes(props.type) ? props.type : props.typeHtml || 'button'
      }
      title={props.title}
      style={{ ...props.style }}
      className={classesBouton.join(' ')}
      onClick={props.cliquer}
      onDoubleClick={props.dobleClique}
      disabled={props.desactive ? 'disabled' : null}
    >
      {icone}
      {props.children} {contentHoverText}
    </button>
  );
};

export default Bouton;
